import {User} from '@app/core/models/user.model';
import {Group} from '@app/core/models/group.model';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {Department} from '@app/core/models/department.model';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';
import {Pagination} from '@app/core/models/pagination.model';
import {ISalaryTotalsCalculation} from '@app/core/services/api/statistic.service';
import {IDepartmentWithSalaryTotals, IPermanentlyEmployedCalculation} from '@app/core/interfaces/salary';
import {PermanentlyEmployedSettings} from '@app/core/models/permanentlyEmployedSettings.model';

export interface IEmployeeSalaryCalculation {
	user: User;
	salary_totals_calculation: ISalaryTotalsCalculation;
	departments_with_salary_totals_calculation_collection: IDepartmentWithSalaryTotals;
	permanently_employed_calculation: IPermanentlyEmployedCalculation;
	permanently_employed_settings: PermanentlyEmployedSettings;
}

export interface IEmployeesState {
	isLoading: boolean;
	users: User[];
	groups: Group[];
	allGroups: Group[];
	departments: Department[];
	editingUser: User;
	socialSecurityNumber: string;
	editingGroup: Group;
	userFiles: FileEntry[];
	isSeeingEmployees: boolean;
	showAllUsers: boolean;
	shouldReloadUsers: boolean;
	shouldReloadGroups: boolean;
	departmentsFilter: number[];
	searchQuery: string;
	supplementalSalaries: SupplementalSalary[];
	supplementalSalariesPagination: Pagination;
	autoSupplementalSalaries: SupplementalSalary[];

	salaryCalculation: IEmployeeSalaryCalculation;
	isSalaryCalculationLoading: boolean;
	salaryCalculationMonth: number;
}

export const initialEmployeesState: IEmployeesState = {
	isLoading: false,
	users: [],
	groups: [],
	allGroups: [],
	departments: [],
	editingUser: undefined,
	socialSecurityNumber: undefined,
	editingGroup: undefined,
	userFiles: [],
	isSeeingEmployees: true,
	showAllUsers: false,
	shouldReloadUsers: false,
	shouldReloadGroups: false,
	departmentsFilter: [],
	searchQuery: null,
	supplementalSalaries: [],
	supplementalSalariesPagination: undefined,
	autoSupplementalSalaries: [],
	salaryCalculation: undefined,
	isSalaryCalculationLoading: false,
	salaryCalculationMonth: undefined,
};
